










import { standardExhibition } from "./standard-exhibition"











//prevent from removing " " from non "xxx-xxx" pattern.
// prettier-ignore
export const extensionConfigs = {
  
  
  
  
  
  
  
  
  
  
  
  "standard-exhibition": standardExhibition,
  
  
  
  
  
  
  
  
  
  
}
